import {
  vBoolean,
  vFallback,
  vObject,
  vOptional,
  type vOutput,
  vString,
  vStringToNumber,
} from '../validation/index.ts'

export const adminLoadUploadFilterSchema = vObject({
  limit: vFallback(vStringToNumber(), 50),
  continuationToken: vOptional(vString()),
  accountId: vOptional(vString()),
  includeArchived: vOptional(vBoolean()),
})
export type AdminLoadUploadFilter = vOutput<typeof adminLoadUploadFilterSchema>
